<template>
    <div v-if="location && location.title">
        <div class="row-section">
            <h3 v-html="location.title"></h3>
            <div class="row">
                <div class="schedule-status">
                    <div class="download-catering" v-if="location.catering_menu">
                        <a :href="location.catering_menu" target="_blank">
                            <i class="fal fa-file-pdf fa-fw"></i> Download Catering Menu
                        </a>
                    </div>
                    <div class="wrap-links">
                        <a v-if="location.pick_up && location.pick_up.url"
                           class="link-cta dark"
                           :href="location.pick_up.url"
                           target="_blank">
                            {{location.pick_up.title || 'Pick Up'}}
                        </a>
                        <a v-if="location.delivery && location.delivery.url"
                           class="link-cta dark"
                           :href="location.delivery.url"
                           target="_blank">
                            {{location.delivery.title || 'Delivery'}}
                        </a>
                    </div>
                </div>
                <div class="info_columns">
                    <div class="col-left">
                        <div v-html="location.address.address"/>
                        <div v-if="location.address_link">
                            <a :href="location.address_link" target="_blank" title="Google Maps Get Directions"><i class="fal fa-map-marked-alt fa-fw"></i> Get Directions</a>
                        </div>
                        <div class="hidden">Toggle Preferred Location</div>
                    </div>
                    <div v-if="phoneNumber.url"
                         class="col-right">
                        <a :href="phoneNumber.url"><i class="fal fa-phone fa-fw"></i> {{phoneNumber.title}}</a>
                    </div>
                </div>
            </div>
        </div>

        <div class="row-section">
            <h4>Hours</h4>
            <div class="row">
                <ul class="schedule">
                    <li v-for="(scheduleItem, index) in location.work_hours" class="schedule-item">
                        <span class="schedule_day" v-html="scheduleItem.day"></span>
                        <span class="schedule_time" v-html="scheduleItem.time"></span>
                    </li>
                </ul>
            </div>
        </div>
        <div
            v-if="careersLink.url"
            class="row-section"
        >
            <h4>Careers</h4>
            <div class="row">
                <div><a :href="careersLink.url" :title="careersLink.title">Apply for job</a></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'app',
        props: {
            location: {
                type: Object
            }
        },
        data() {
            return {}
        },
        computed: {
            phoneNumber() {
                return this.location.phone_number || {};
            },
            careersLink() {
                return this.location.careers_link || {};
            },
        },
    }
</script>

<style lang="scss" scoped>

    .wrap-links {
        a{
            margin: 0 5px 15px 0;
        }
    }
</style>

<style lang="scss">

    .hidden {
        display: none;
    }

    .info_columns {
        display: flex;

        .col-left {
            padding-right: 15px;
            width: 50%;
        }

        .col-right {
            width: 50%;
        }
    }

    .schedule {
        list-style: none;
        margin: 0 0 40px 0px;
        padding: 0;

        .schedule-item {
            display: flex;
        }
    }

    .schedule-status {
        padding-bottom: 25px;
        width: 50%;
    }

    .schedule_day {
        font-weight: 700;
        width: 50%;
    }

    .download-catering {
        margin-bottom: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/LocationDetails.vue